// Generated by https://quicktype.io

export class MyFocusLoyaltyMemberDTO {
	AcctNo: string;
	FirstName: string;
	LastName: string;
	LoyaltyStatus: string;
	GCBalance: string;
	Plan: Plan[];

	public constructor(init?: Partial<MyFocusLoyaltyMemberDTO>) {
		Object.assign(this, init);
	}
}

class Plan {
	PlanID: string;
	PlanStatus: string;
	PlanName: string;
	PlanType: string;
	EnableUpdate: string;
	DisplayOnCHIT: string;
	PlanCompleted: string;
	CurrentItemCount?: string;
	PlanMeasurement: string;
	PlanValue: string;
	Discounts: DiscountsClass | string;
}

class DiscountsClass {
	Discount: DiscountElement[] | DiscountElement;
}

class DiscountElement {
	DiscountID: string;
	DiscountName: string;
	DiscountCount: string;
}
